var map = {
	"./base.svg": "f55f",
	"./cheek.svg": "c781",
	"./cleansing.svg": "78f0",
	"./concealer.svg": "d4af",
	"./eyeliner.svg": "26d1",
	"./eyeshadow.svg": "c678",
	"./facepowder.svg": "4cd6",
	"./facewash.svg": "e942",
	"./foundation.svg": "346f",
	"./highlight.svg": "72da",
	"./lip.svg": "6bfc",
	"./losion.svg": "1c39",
	"./mascara.svg": "a5d5",
	"./milk.svg": "f003",
	"./pencil_eyebrow.svg": "3585",
	"./powder_eyebrow.svg": "bdc3",
	"./shading.svg": "3d5e",
	"./special_care.svg": "4048"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ed3";